'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slate');

/**
 * True if the node is a list container
 */
function isList(opts, node) {
  return opts.types.includes(node.type);
}
exports.default = isList;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-edit-list/dist/utils/isList.js
// module id = 240
// module chunks = 0